import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import "./Components/profile/dashboard.css";
import { Provider } from "react-redux";
import {store,persistor} from "./store/store";
import { ToastContainer } from "react-toastify";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
  <PersistGate persistor={persistor}>
  <App/>
  </PersistGate>
  <ToastContainer
  autoClose={2000}
/>
  </Provider>
);
